import { ICreateRentComp } from "pages/Comps/components/RentCompModal/interfaces";
import { apiClient } from "lib/apiClient";

type Response = {
  name: string;
  ownerRelatedStatus: string;
  closingDate: string;
  pricePerUnit: number;
  properties: string[];
  participantData: string;
  verificationSources: string[];
  participantCompanyName: string;
  participantName: string;
  participantPhone: string;
  participantEmail: string;
  sellerLegalName: string;
  sellerTrueName: string;
  sellerProfitType: string;
  buyerLegalName: string;
  buyerTrueName: string;
  buyerProfitType: string;
  id: string;
};

export const addRentComp = async (
  request: ICreateRentComp,
  originalCompId: string | null
): Promise<Response> => {
  const response = await apiClient.post(
    `/comps/rent${originalCompId ? `?originalCompId=${originalCompId}` : ""}`,
    request
  );

  return response.data;
};
